import { HeroUIProvider, ToastProvider } from '@heroui/react'
import { useNavigate } from 'react-router'

interface UIProviderProps {
  children: React.ReactNode
}

export function UIProvider({ children }: UIProviderProps) {
  const navigate = useNavigate()
  // disableRipple: @react-aria usePress returns wrong coordinates (0,0) in React 19
  // disableAnimation: Framer Motion 12 runs exit variant on entry, making modals invisible
  return (
    <HeroUIProvider navigate={navigate} disableRipple disableAnimation>
      {/* Mounted once for every app, so `addToast` works from anywhere without
          each screen wiring up its own. Bottom-centre keeps confirmations away
          from the sidebar and off the form being used. */}
      <ToastProvider placement="bottom-center" toastProps={{ timeout: 4000 }} />
      {children}
    </HeroUIProvider>
  )
}
